<template>
  <div class="body-width  div-top">
    <ul class="breadcrumb">      
      <li  @mouseenter="handleEnter('/productznhy/zncbajyckzz')" @mouseleave="handleLeave('/productznhy/zncbajyckzz')">
        <a @click="setroters('/productznhy/zncbajyckzz')">
          <span :class="zncbajyckzz===true?'font-Normal-1400':'font-Normal-14B6'">智能船舶岸基远程控制站系统</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/productznhy/zxlykwrtjcspt')" @mouseleave="handleLeave('/productznhy/zxlykwrtjcspt')">
        <a @click="setroters('/productznhy/zxlykwrtjcspt')">
          <span :class="zxlykwrtjcspt===true?'font-Normal-1400':'font-Normal-14B6'">ZLUSV系列远控无人挺及测试平台</span>
        </a>   
      </li>
      <li @mouseenter="handleEnter('/productznhy/znzzjsjxtload')" @mouseleave="handleLeave('/productznhy/znzzjsjxtload')">
        <a @click="setroters('/productznhy/znzzjsjxtload')">
          <span :class="znzzjsjxtload===true?'font-Normal-1400':'font-Normal-14B6'">智能装载计算机系统-SmartLoad</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/productznhy/cbqxdhxt')" @mouseleave="handleLeave('/productznhy/cbqxdhxt')">
        <a @click="setroters('/productznhy/cbqxdhxt')">
          <span :class="cbqxdhxt===true?'font-Normal-1400':'font-Normal-14B6'">船舶气象导航系统</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/productznhy/zhhsjzqxt')" @mouseleave="handleLeave('/productznhy/zhhsjzqxt')">
        <a @click="setroters('/productznhy/zhhsjzqxt')">
          <span :class="zhhsjzqxt===true?'font-Normal-1400':'font-Normal-14B6'">ZLNAVAR航海视觉增强系统</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/productznhy/fzsycbznbp')" @mouseleave="handleLeave('/productznhy/fzsycbznbp')">
        <a @click="setroters('/productznhy/fzsycbznbp')">
          <span :class="fzsycbznbp===true?'font-Normal-1400':'font-Normal-14B6'">复杂水域船舶智能避碰辅助决策系统</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/productznhy/cbarycywxt')" @mouseleave="handleLeave('/productznhy/cbarycywxt')">
        <a @click="setroters('/productznhy/cbarycywxt')">
          <span :class="cbarycywxt===true?'font-Normal-1400':'font-Normal-14B6'">船舶AR远程运维系统</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/productznhy/swszdqcp')" @mouseleave="handleLeave('/productznhy/swszdqcp')">
        <a @click="setroters('/productznhy/swszdqcp')">
          <span :class="swszdqcp===true?'font-Normal-1400':'font-Normal-14B6'">三维数字地球产品</span>
        </a>
      </li>                                  
    </ul>
  </div>

</template>
<script>
  export default {
    name: "hhxnsxxheader",
    data() {
      return {
        zncbajyckzz: false,
        zxlykwrtjcspt: false,
        znzzjsjxtload: false,
        cbqxdhxt: false,
        zhhsjzqxt:false,
        fzsycbznbp:false,
        cbarycywxt:false,
        swszdqcp:false,
     
        
        iszncbajyckzz:false,
        iszxlykwrtjcspt:false,
        isznzzjsjxtload:false,
        iscbqxdhxt:false,
        iszhhsjzqxt:false,
        isfzsycbznbp:false,
        iscbarycywxt:false,
        isswszdqcp:false,
      }
    },
    methods: {
      handleEnter(src) {
        if (src === '/productznhy/zncbajyckzz') {
          this.zncbajyckzz = true
        }
        if (src === '/productznhy/zxlykwrtjcspt') {
          this.zxlykwrtjcspt = true
        }
        if (src === '/productznhy/znzzjsjxtload') {
          this.znzzjsjxtload = true
        }
        if (src === '/productznhy/cbqxdhxt') {
          this.cbqxdhxt = true
        }
        if (src === '/productznhy/zhhsjzqxt') {
          this.zhhsjzqxt = true
        }
        if (src === '/productznhy/fzsycbznbp') {
          this.fzsycbznbp = true
        }
        if (src === '/productznhy/cbarycywxt') {
          this.cbarycywxt = true
        }
        if (src === '/productznhy/swszdqcp') {
          this.swszdqcp = true
        }
      },


      handleLeave(src) {
        if (src === '/productznhy/zncbajyckzz') {
          if(!this.iszncbajyckzz){
            this.zncbajyckzz = false
          }
        }
        if (src === '/productznhy/zxlykwrtjcspt') {
          if(!this.iszxlykwrtjcspt){
            this.zxlykwrtjcspt = false
          }
        }
        if (src === '/productznhy/znzzjsjxtload') {
          if(!this.isznzzjsjxtload){
            this.znzzjsjxtload = false
          }
        }
        if (src === '/productznhy/cbqxdhxt') {
          if(!this.iscbqxdhxt){
            this.cbqxdhxt = false
          }
        }
        if (src === '/productznhy/zhhsjzqxt') {
          if(!this.iszhhsjzqxt){
            this.zhhsjzqxt = false
          }
        }
        if (src === '/productznhy/fzsycbznbp') {
          if(!this.isfzsycbznbp){
            this.fzsycbznbp = false
          }
        }
        if (src === '/productznhy/cbarycywxt') {
          if(!this.iscbarycywxt){
            this.cbarycywxt = false
          }
        }
        if (src === '/productznhy/swszdqcp') {
          if(!this.isswszdqcp){
            this.swszdqcp = false
          }
        }
      },

      setroters(src) {
        if (src === '/productznhy/zncbajyckzz') {
          this.zncbajyckzz = true
          this.iszncbajyckzz = true
        } else {
          this.zncbajyckzz = false
          this.iszncbajyckzz = false
        }
        if (src === '/productznhy/zxlykwrtjcspt') {
          this.zxlykwrtjcspt = true
          this.iszxlykwrtjcspt = true
        } else {
          this.zxlykwrtjcspt = false
          this.iszxlykwrtjcspt = false
        }
        if (src === '/productznhy/znzzjsjxtload') {
          this.znzzjsjxtload = true
          this.isznzzjsjxtload = true
        } else {
          this.znzzjsjxtload = false
          this.isznzzjsjxtload = false
        }
        if (src === '/productznhy/cbqxdhxt') {
          this.cbqxdhxt = true
          this.iscbqxdhxt = true
        } else {
          this.cbqxdhxt = false
          this.iscbqxdhxt = false
        }
        if (src === '/productznhy/zhhsjzqxt') {
          this.zhhsjzqxt = true
          this.iszhhsjzqxt = true
        } else {
          this.zhhsjzqxt = false
          this.iszhhsjzqxt = false
        }
        if (src === '/productznhy/fzsycbznbp') {
          this.fzsycbznbp = true
          this.isfzsycbznbp = true
        } else {
          this.fzsycbznbp = false
          this.isfzsycbznbp = false
        }
        if (src === '/productznhy/cbarycywxt') {
          this.cbarycywxt = true
          this.iscbarycywxt = true
        } else {
          this.cbarycywxt = false
          this.iscbarycywxt = false
        }
        if (src === '/productznhy/swszdqcp') {
          this.swszdqcp = true
          this.isswszdqcp = true
        } else {
          this.swszdqcp = false
          this.isswszdqcp = false
        }
        this.$router.push(src);
      }
    },
    mounted() {
      this.setroters('/productznhy/zncbajyckzz');
    }
  }

</script>

<style scoped>
  .div-top {
    margin-top: 50px;
  }
.breadcrumb{
   background-color: #fbfbfb !important;
}
  .breadcrumb > li + li:before {
 
    color: #666666;
    content: "| ";
    padding: 0 16px;
  }
  .li-padding-left20 {
    padding-left: 20px;
  }

.font-Normal-1400,
.font-Normal-14B6 {
  font-size: 17px; /* 固定基础字号，两个class字号保持一致 */
  font-weight: 600;
  /* 新增缩放过渡，只做视觉变化，不改变布局 */
  transition: transform 0.2s ease;
  display: inline-block; /* transform生效必备 */
  transform-origin: center; /* 居中放大，避免单侧偏移拉扯 */
}

/* 选中态只用scale放大，不改字号 */
.font-Normal-1400 {
  transform: scale(1.13); /* 视觉放大效果，替代增大font-size */
}



</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/znhyxlcp/znhyheader.vue